import React from 'react';

import { track } from 'utils/analytics';

import './index.css';

/* global FB, screen */
const handleFBClick = () => {
	FB.ui({
		method: 'share',
		href: 'https://www.refinery29.com/en-us/target-swimwear-collection-summer-2019/',
	}, response => {});
	track('clicked', 'facebook');
}

const handleTWClick = () => {
	const url = 'https://www.refinery29.com/en-us/target-swimwear-collection-summer-2019/';
	const text = 'Looking For A Swimsuit That Fits Your Vibe & Your Body Type? Take This Quiz';
	const width = 640;
	const height = 400;
	const left = window.screen.availLeft + (window.screen.availWidth - width) / 2;
	const top = window.screen.availTop + (window.screen.availHeight - height) / 2;
	track('clicked', 'twitter');
	window.open(`http://twitter.com/share?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '', `width=${width},height=${height},left=${left},top=${top}`);
}

export default function Header(props) {
	return (
		<header className="header">
			<img className="logo" src="https://s3.r29static.com//bin/public/c8f/x/1999824/image.png" alt="refinery29 logo" />
			<div className="share">
				<img className="facebook icon" src="https://s1.r29static.com//bin/public/a98/x/1999823/image.png" onClick={handleFBClick.bind(this)} alt="facebook logo" />
				<img className="twitter icon" src="https://s1.r29static.com//bin/public/6ec/x/1999827/image.png" onClick={handleTWClick.bind(this)} alt="twitter logo" />
			</div>
		</header>
	);
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js